import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ALL_LANGS, ROUTES } from "~/const";
import { getLink, overrideLang } from "~/providers/lang";

export default function Redirect() {
	const navigation = useNavigate();

	useEffect(() => {
		// check na routu
		const paths = location.pathname.split("/").filter(item => item);
		let newUrl = "";

		if (paths.length === 1) {
			const curPath = paths[0];

			// zkusime jazyky
			if (ALL_LANGS.includes(curPath)) {
				overrideLang(curPath);
				newUrl = getLink(ROUTES.home);
			} else {
				// zkusime naroubovat na soucasne cesty
				const allOptions = Object.entries(ROUTES);

				for (const routeOption of allOptions) {
					const values = Object.values(routeOption[1]);

					if (values.includes(curPath)) {
						overrideLang("cs");
						newUrl = getLink(ROUTES[routeOption[0]]);
						break;
					}
				}
			}
		}

		if (!newUrl) {
			newUrl = getLink(ROUTES.page404);
		}

		navigation(newUrl);
	}, []);

	return null;
}
